import {
  FormattedPriceCalculationResponse,
  PricingPeriod
} from '@atlassiansox/bxp-use-pricing';
import { Action } from 'react-sweet-state';
import { PriceFinderState } from '../models';

export const updateUnitCount =
  (unitCount: number): Action<PriceFinderState> =>
  ({ setState }) => {
    setState({
      unitCount
    });
  };

export const updateBillingCycle =
  (billingCycle: PricingPeriod): Action<PriceFinderState> =>
  ({ setState }) => {
    setState({
      billingCycle
    });
  };

export const updatePriceCalcs =
  (priceCalcs: FormattedPriceCalculationResponse[]): Action<PriceFinderState> =>
  ({ setState }) => {
    setState({
      priceCalcs
    });
  };
